var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",style:({ height: 'auto' }),attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":"userLists"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }